import * as React from 'react';

import {Field} from 'redux-form';

import {FormField} from 'shells/form/form-field';
import {nonNull} from 'shells/form/validation/non-null';

import {PipelineSelectSingle} from './pipeline-select-single';

export function LeadWonForm() {
    return (
        <FormField innerId='leadWon' label='Which pipeline?'>
            <Field name='leadWon' component={PipelineSelectSingle} validate={[nonNull]} />
        </FormField>
    );
}
